import { IProgressWidgetColors } from '@user/components/Opportunities/AddOpportunityPage/AddOpportunityForm/FormComponents/OpportunityStageMeter/ProgressWidget/typings'
import { Theme } from '@mui/material/styles'
import { IListItemStylesProps } from './typings'

export const listStyles = {
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    padding: 0,
  },
}

export const getListItemStyles = (
  props: IListItemStylesProps,
  theme: Theme,
) => ({
  root: {
    marginLeft: props.marginLeft === undefined ? -12 : props.marginLeft,
    padding: theme.spacing(0),
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },

  test: {},
})

export const listItemLabelStyle = (
  width: number,
  height: number,
  theme: Theme,
): React.CSSProperties => {
  return {
    color: theme.palette.common.white,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: 12,
    lineHeight: `${height}px`,
    width: `${width}px`,
    height: `${height}px`,
    position: 'absolute',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
}

export const colors = (theme: Theme): IProgressWidgetColors => {
  return {
    completeColors: {
      backgroundColor: '#19305a',
      backgroundColorHover: '#122240',
      textColor: theme.palette.common.white,
      textColorHover: theme.palette.common.white,
      strokeColor: '#19305a',
      strokeColorHover: '#122240',
    },
    incompleteColors: {
      backgroundColor: '#ebeff3',
      backgroundColorHover: '#f7f7f7',
      textColor: '#19305a',
      textColorHover: '#122240',
      strokeColor: '#375ba3',
      strokeColorHover: '#375ba3',
    },
  }
}
